import { useEffect } from "react";
import { styled } from "styled-components";

import { InfinityLoader, SectionTitleUnderlined, StyledGrid as Grid } from "common/components";
import { CollectionTile } from "common/components/collectionTile/CollectionTile";
import { breakpoints } from "common/styles";
import { Status } from "common/types/status";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { fetchCollections } from "domains/collection/actions";
import {
  getCollectionsNextPageMayExist,
  getCollectionsOffset,
  getCollectionsStatus,
  getEditableCollections,
} from "domains/collection/selectors";
import { CollectionType } from "domains/collection/types/collectionType";
import { CreateNewCollectionSection } from "domains/create/landing/CreateNewCollectionSection";

const StyledGridContainer = styled.div`
  padding-bottom: 1rem;
  margin: 1rem;

  @media ${breakpoints.medium} {
    margin: 1rem 2rem 2rem;
  }

  @media ${breakpoints.extraLarge} {
    margin: 1rem 3rem 3rem;
  }
`;

const StyledGrid = styled(Grid)`
  grid-gap: 3rem 1rem;
`;

export const CreateCollectionsTab = () => {
  const dispatch = useDispatch();
  const nextPageMayExist = useSelector(getCollectionsNextPageMayExist);
  const offset = useSelector(getCollectionsOffset);
  const status = useSelector(getCollectionsStatus);
  const editable = useSelector(getEditableCollections);
  const track = useTrack();
  const translate = useTranslate();

  useEffect(() => {
    track({ name: "Browse page", page: "Create landing", subpage: "Create landing - collections tab" });
  }, [track]);

  const fetchNextPage = () => dispatch(fetchCollections(CollectionType.Editable, offset.editable));

  return (
    <>
      <CreateNewCollectionSection />
      <StyledGridContainer>
        <SectionTitleUnderlined>{translate("app.create.collection.title")}</SectionTitleUnderlined>
        {editable.length > 0 && (
          <InfinityLoader
            isPending={status.editable === Status.Loading}
            loadNextPage={fetchNextPage}
            hasNextPage={nextPageMayExist.editable}
          >
            <StyledGrid numberOfItems={[1, 2, 3, 4, 5]}>
              {editable.map((collection) => (
                <CollectionTile collection={collection} key={collection.id} />
              ))}
            </StyledGrid>
          </InfinityLoader>
        )}
      </StyledGridContainer>
    </>
  );
};
